<template>
    <div class="blackout" :class="{blocked: blocked, show: show}">
        <div class="content vertical-align">
            <Spinner />
            <div class="message" :class="{show : processingMsg}">{{processingMsg}}</div>
            <div class="message" :class="{show : slowLoadMsg}">{{slowLoadMsg}}</div>
        </div>
    </div>
</template>

<script>
    import Spinner from '../icons/Spinner';
    export default {
        name: 'LoadingScreen',
        components: {Spinner},
        props: [
            'display'
        ],
        data: function() {
            return {
                show: false,
                blocked: false,
                timeout: null,
                slowLoadingTimer: null,
                slowLoadMsg: false
            };
        },
        computed: {
            isOccupied() {
                return this.$store.state.activity.fetching || this.$store.state.activity.uploading;
            },
            processingMsg() {
                return this.$store.state.activity.processingMsg;
            }
        },
        created() {
            this.toggleDisplay();  
        },
        watch: {
            isOccupied() {
                this.toggleDisplay();
            },
            show() {
                if (this.show === true){
                    document.body.classList.add('no-scroll'); 
                } else {
                    document.body.classList.remove('no-scroll'); 
                }
            },
            processingMsg(val) {
                if (val){
                    this.startSlowMsgTimeout();
                }
            }
        },
        methods: {
            toggleDisplay() {
                if(this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }
                if(this.slowLoadingTimer) {
                    clearTimeout(this.slowLoadingTimer);
                    this.slowLoadingTimer = null;
                }
                if(this.isOccupied) {
                    this.show = false;
                    this.blocked = true;
                    this.timeout = setTimeout(() => {
                        this.show = true;
                    }, 10);
                    this.startSlowMsgTimeout();
                } else {           
                    this.blocked = true;
                    this.show = false;
                    this.slowLoadMsg = '';
                    this.timeout = setTimeout(() => {
                        this.blocked = false;
                    }, 500);
                }
                
            },
            startSlowMsgTimeout() {
                clearTimeout(this.slowLoadingTimer);
                this.slowLoadingTimer = setTimeout(() => {
                    this.slowLoadMsg = 'Still Working...';
                    
                    this.slowLoadingTimer = setTimeout(() => {
                        this.slowLoadMsg = 'Sorry, this is taking a bit longer than expected...';
                    }, 9000);
                    
                }, 3000);
            }
            
        }
    };
</script>

<style scoped>
    
    .blackout {background-color: rgba(0,0,0,.9); position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 999; cursor: progress; opacity: 0; transition: .5s; display: none;}
    .blackout.show {transition-delay: .15s; opacity: 1;}
    .blackout.blocked {display: block;}
        .blackout .content {color: #fff; text-align: center; width: 90vw; max-width: 35rem; position: absolute; right: 0; left: 0; margin: auto;}
        .blackout .content > .spinner {margin: auto;}
        .blackout .content > .message {font-size: .8rem; padding-top: 0; opacity: 0; max-height: 0; overflow: hidden; transition: .25s;}
        .blackout .content > .message.show {padding-top: 1.5rem; opacity: 1; max-height: 5rem;}
        /*.blackout > .spinner {position: absolute; top: 0; right: 0; bottom: 0; left: 0; margin: auto;}*/

</style>